export default "__VITE_ASSET__24e4929e__"